import { useEffect, useRef, useState } from 'react';

export const BLOCK_DISMISS_TIMEOUT_MS = 500;

/**
 * Manages dismiss state for a single status block.
 * @param shouldScheduleDismiss - triggers a timed dismiss (e.g. block completed)
 * @param shouldImmediateDismiss - triggers an instant dismiss (e.g. not latest message)
 * @returns whether the block has been dismissed
 */
export const useBlockDismissTimer = (
  shouldScheduleDismiss: boolean,
  shouldImmediateDismiss: boolean,
): boolean => {
  const [dismissed, setDismissed] = useState(false);
  const scheduledRef = useRef(false);

  useEffect(() => {
    if (shouldImmediateDismiss) {
      setDismissed(true);
      return;
    }

    if (shouldScheduleDismiss && !scheduledRef.current) {
      scheduledRef.current = true;
      setTimeout(() => setDismissed(true), BLOCK_DISMISS_TIMEOUT_MS);
    }
  }, [shouldScheduleDismiss, shouldImmediateDismiss]);

  return dismissed;
};
